/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { withI18n } from '../../../hocs';
import { MSG_CONTENT_TYPES, MSG_SEND_TYPE, MSG_STATUS } from '../../../models';
import { MessageStatusService } from '../../../services';
import EventFlowMessageBubble from '../event-flow-message-bubble';
import MultimediaMessageBubble from '../multimedia-message-bubble';
import QuickReplyMessageBubble from '../quickReply-message-bubble';
import TemplateMessageBubble from '../template-message-bubble';
import TextMessageBubble from '../text-message-bubble';
import { MessagesListStyled } from './styled';
import {
  getLabelInteractiveList,
  getLabelInteractiveButton,
  getLabelTemplate,
  getJsxLinkedMessage,
  mergeAndSortByTimespan,
} from './utils';

const getMessageFromContentType = (contentType, content, i18n) => {
  let message = '';
  switch (contentType) {
    case MSG_CONTENT_TYPES.TEXT:
      message = content.body;
      break;
    case MSG_CONTENT_TYPES.IMAGE:
      message = content.caption;
      break;
    case MSG_CONTENT_TYPES.VIDEO:
      message = content.caption;
      break;
    case MSG_CONTENT_TYPES.DOCUMENT:
      message = content.caption;
      break;
    case MSG_CONTENT_TYPES.STICKER:
    case MSG_CONTENT_TYPES.VOICE:
    case MSG_CONTENT_TYPES.AUDIO:
    case MSG_CONTENT_TYPES.LOCATION:
    case MSG_CONTENT_TYPES.CONTACTS:
      break;
    default:
      message = i18n.chats.notAbleToShowMessage;
  }
  return message;
};

const getColorClassFromSendType = (messageSendType) => {
  let colorClass = '';
  switch (messageSendType) {
    case MSG_SEND_TYPE.OPERATOR:
      colorClass =
        'message-bubble-shape-operator message-bubble-color-operator';
      break;
    case MSG_SEND_TYPE.PROACTIVE:
      colorClass = 'message-bubble-shape-proactive message-bubble-color-bot';
      break;
    case MSG_SEND_TYPE.INPUT:
      colorClass = 'message-bubble-shape message-bubble-color-input';
      break;
    default:
      colorClass = 'message-bubble-shape-bot message-bubble-color-bot';
  }
  return colorClass;
};

// TODO: Refactor Message List to have a MessageItem.
// TODO: Message Item will render a Bubble depending on teh type: Text or Multimedia
// TODO: Extract Message  Text Bubble for wrapping the three kind of possible text message: ok, deleted or unknown
// TODO: Extract Multimedia Bubble to a common wrapper for each kind of multimedia type bubble
const MessagesList = ({
  chat,
  i18n,
  formatDateString,
  onMultimediaClick,
  messagesPending,
}) => {
  const cleanNoMessagesIds = chat.messages.filter(
    (element) => element?.messageId
  );
  const messagesWithPending = mergeAndSortByTimespan(
    cleanNoMessagesIds || [],
    messagesPending || []
  );
  const list = messagesWithPending.map((mes, index) => {
    const {
      contentType,
      messageId,
      sendType,
      type,
      timespan,
      content = {},
      status,
    } = mes || {};
    const message = getMessageFromContentType(contentType, content, i18n);
    const multiMediaResource = content.multimediaUrl;
    const isTextMessage = contentType === MSG_CONTENT_TYPES.TEXT;
    const isImageMessage = contentType === MSG_CONTENT_TYPES.IMAGE;
    const isVideoMessage = contentType === MSG_CONTENT_TYPES.VIDEO;
    const isStickerMessage = contentType === MSG_CONTENT_TYPES.STICKER;
    const isContactsMessage = contentType === MSG_CONTENT_TYPES.CONTACTS;
    const isLocationMessage = contentType === MSG_CONTENT_TYPES.LOCATION;
    const isDocumentMessage = contentType === MSG_CONTENT_TYPES.DOCUMENT;
    const isVoiceMessage = contentType === MSG_CONTENT_TYPES.VOICE;
    const isAudioMessage = contentType === MSG_CONTENT_TYPES.AUDIO;
    const isVoiceOrAudioMessage = isVoiceMessage || isAudioMessage;
    const isInteractiveMessage = contentType === MSG_CONTENT_TYPES.INTERACTIVE;
    const isTemplateMessage = contentType === MSG_CONTENT_TYPES.TEMPLATE;
    const isQuickReplyMessage = contentType === MSG_CONTENT_TYPES.QUICK_REPLY;
    const isUnknownMessage = contentType === MSG_CONTENT_TYPES.UNKNOWN;
    const isEventFlowMessage = contentType === MSG_CONTENT_TYPES.EVENT;
    let eventFlowLinkedMessageToPaint;
    let resourceId;
    if (content && content.id) resourceId = content.id;
    if (content && content.multimediaId) resourceId = content.multimediaId;
    const messageSendType = sendType || type;
    const isPathbotEventMessage =
      isEventFlowMessage && messageSendType === MSG_SEND_TYPE.PATHBOT;
    const colorClass = getColorClassFromSendType(messageSendType);
    const date = moment(timespan).format(formatDateString);
    const key = messageId || `MessagesList${index}`;
    const { channel } = chat;
    let { statusIcon } =
      channel !== 'messenger' &&
      MessageStatusService.getStatusIcon(status, channel);
    const { deletedIcon, errorIcon } =
      channel !== 'messenger' &&
      MessageStatusService.getStatusIcon(status, channel);
    if (!mes.messageId) {
      statusIcon = MessageStatusService.getStatusIcon(
        MSG_STATUS.TRYING_AGAIN.VALUE
      ).statusIcon;
    }

    let quickReplyLinkedMessage;
    let labelQuickReply;
    if (isQuickReplyMessage && mes?.content?.messageId) {
      const linkedMessage = cleanNoMessagesIds?.find(
        (el) => el?.messageId === mes?.content?.messageId
      );

      const payloadMessage = mes?.content?.eventName;

      if (linkedMessage?.contentType === MSG_CONTENT_TYPES.TEMPLATE) {
        labelQuickReply = getLabelTemplate(linkedMessage, payloadMessage);
      }
      if (linkedMessage?.contentType === MSG_CONTENT_TYPES.INTERACTIVE) {
        if (linkedMessage?.content?.interactive?.type === 'list') {
          labelQuickReply = getLabelInteractiveList(
            linkedMessage,
            payloadMessage
          );
        }
        if (linkedMessage?.content?.interactive?.type === 'button') {
          labelQuickReply = getLabelInteractiveButton(
            linkedMessage,
            payloadMessage
          );
        }
      }
      if (linkedMessage) {
        quickReplyLinkedMessage = getJsxLinkedMessage(linkedMessage);
      }
    }
    if (isEventFlowMessage) {
      const linkedMessageId =
        mes?.content?.eventParameters?.flowResponse?.flowToken?.flowMessageId;
      const linkedMessage =
        typeof linkedMessageId === 'number' &&
        cleanNoMessagesIds?.find((el) => el?.messageId === linkedMessageId);
      eventFlowLinkedMessageToPaint = getJsxLinkedMessage(linkedMessage);
    }

    return (
      <div key={key} id={`msg-${messageId}`}>
        {deletedIcon ? (
          <TextMessageBubble
            colorClass={colorClass}
            date={null}
            deletedIcon={deletedIcon}
            message={i18n.chats.messageWasDeleted}
            sendType={sendType}
            statusIcon={null}
          />
        ) : (
          <>
            {isTextMessage && (
              <TextMessageBubble
                colorClass={colorClass}
                date={date}
                deletedIcon={deletedIcon}
                errorIcon={errorIcon}
                message={message}
                sendType={sendType}
                statusIcon={statusIcon}
              />
            )}
            {isTemplateMessage && (
              <TemplateMessageBubble
                colorClass={colorClass}
                content={content}
                date={date}
                deletedIcon={deletedIcon}
                errorIcon={errorIcon}
                message={message}
                onMultimediaClick={onMultimediaClick}
                sendType="operator"
                statusIcon={statusIcon}
              />
            )}
            {isEventFlowMessage && !isPathbotEventMessage && (
              <EventFlowMessageBubble
                colorClass={colorClass}
                content={content}
                date={date}
                deletedIcon={deletedIcon}
                errorIcon={errorIcon}
                linkedMessage={eventFlowLinkedMessageToPaint}
                onMultimediaClick={onMultimediaClick}
                sendType="operator"
                statusIcon={statusIcon}
              />
            )}
            {isPathbotEventMessage && (
              <TextMessageBubble
                colorClass={colorClass}
                date={date}
                deletedIcon={deletedIcon}
                errorIcon={errorIcon}
                italic
                message={i18n.chats.aiConsultation}
                sendType={sendType}
                statusIcon={statusIcon}
              />
            )}
            {isQuickReplyMessage && (
              <QuickReplyMessageBubble
                colorClass={colorClass}
                date={date}
                deletedIcon={deletedIcon}
                errorIcon={errorIcon}
                label={labelQuickReply}
                linkedMessage={quickReplyLinkedMessage}
                message={
                  content && content.eventName ? content.eventName : message
                }
                sendType={sendType}
                statusIcon={statusIcon}
              />
            )}
            {isUnknownMessage && (
              <TextMessageBubble
                colorClass={colorClass}
                date={date}
                message={message}
                sendType={sendType}
              />
            )}
            {isDocumentMessage && (
              <MultimediaMessageBubble
                caption={message}
                colorClass={colorClass}
                date={date}
                document
                errorIcon={errorIcon}
                id={resourceId}
                resourceURL={multiMediaResource}
                sendType={sendType}
                statusIcon={statusIcon}
              />
            )}
            {isStickerMessage && (
              <MultimediaMessageBubble
                caption={message}
                colorClass={colorClass}
                date={date}
                errorIcon={errorIcon}
                id={resourceId}
                onMultimediaClick={onMultimediaClick}
                resourceURL={multiMediaResource}
                sendType={sendType}
                statusIcon={statusIcon}
                sticker
              />
            )}
            {isContactsMessage && (
              <MultimediaMessageBubble
                caption={message}
                colorClass={colorClass}
                contacts
                content={content[0]}
                date={date}
                errorIcon={errorIcon}
                onMultimediaClick={onMultimediaClick}
                resourceURL={multiMediaResource}
                sendType={sendType}
                statusIcon={statusIcon}
              />
            )}
            {isLocationMessage && (
              <MultimediaMessageBubble
                caption={message}
                colorClass={colorClass}
                content={content}
                date={date}
                errorIcon={errorIcon}
                location
                onMultimediaClick={onMultimediaClick}
                resourceURL={multiMediaResource}
                sendType={sendType}
                statusIcon={statusIcon}
              />
            )}
            {isVideoMessage && (
              <MultimediaMessageBubble
                caption={message}
                colorClass={colorClass}
                date={date}
                errorIcon={errorIcon}
                id={resourceId}
                onMultimediaClick={onMultimediaClick}
                resourceURL={multiMediaResource}
                sendType={sendType}
                statusIcon={statusIcon}
                video
              />
            )}
            {isImageMessage && (
              <MultimediaMessageBubble
                caption={message}
                colorClass={colorClass}
                date={date}
                errorIcon={errorIcon}
                id={resourceId}
                image
                onMultimediaClick={onMultimediaClick}
                resourceURL={multiMediaResource}
                sendType={sendType}
                statusIcon={statusIcon}
              />
            )}
            {isVoiceOrAudioMessage && (
              <MultimediaMessageBubble
                audio
                colorClass={colorClass}
                date={date}
                errorIcon={errorIcon}
                id={resourceId}
                resourceURL={multiMediaResource}
                sendType={sendType}
                statusIcon={statusIcon}
              />
            )}
            {isInteractiveMessage && (
              <MultimediaMessageBubble
                colorClass={colorClass}
                content={content}
                date={date}
                errorIcon={errorIcon}
                id={resourceId}
                interactive
                resourceURL={multiMediaResource}
                sendType={sendType}
                statusIcon={statusIcon}
              />
            )}
          </>
        )}
      </div>
    );
  });

  return <MessagesListStyled>{list}</MessagesListStyled>;
};

MessagesList.propTypes = {
  chat: PropTypes.object,
  formatDateString: PropTypes.string,
  i18n: PropTypes.object,
  messagesPending: PropTypes.array,
  onMultimediaClick: PropTypes.func,
};

export default withI18n(MessagesList);
